import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useLang } from "@/contexts/LangContext";
import { toast } from "sonner";

export default function ForgotPassword() {
  const { lang } = useLang();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success(lang === "tr" ? "İstek alındı" : "Request received");
    } catch (err) {
      toast.error("Error");
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="forgot-password-page" className="px-6 py-20 max-w-md mx-auto">
      <h1 className="font-heading text-4xl mb-2 text-center">{lang === "tr" ? "Şifremi Unuttum" : "Forgot Password"}</h1>
      <p className="text-sm text-center text-[#52525B] mb-10">
        {lang === "tr" ? "Hesabınızın e-posta adresini girin, size sıfırlama bağlantısı oluşturalım." : "Enter your account email and we'll generate a reset link."}
      </p>
      {sent ? (
        <div data-testid="forgot-success" className="bg-[#F5F2EC] p-6 text-sm text-center">
          {lang === "tr" ? "Eğer bu e-posta kayıtlıysa, sıfırlama bağlantısı oluşturuldu. Lütfen yöneticinizle iletişime geçin veya gelen kutunuzu kontrol edin." : "If that email is registered, a reset link has been generated. Please check your inbox or contact your administrator."}
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-6">
          <div>
            <label className="block text-[10px] uppercase tracking-[0.2em] mb-2">{lang === "tr" ? "E-posta" : "Email"}</label>
            <input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="w-full border-b border-[#0A0A0A] bg-transparent py-2 text-sm focus:outline-none focus:border-[#C8A96A]" />
          </div>
          <button data-testid="forgot-submit" disabled={loading} className="w-full bg-[#0A0A0A] hover:bg-[#C8A96A] text-white py-4 text-xs uppercase tracking-[0.25em] transition-colors disabled:opacity-50">
            {loading ? "..." : (lang === "tr" ? "Bağlantı Gönder" : "Send Reset Link")}
          </button>
        </form>
      )}
      <p className="text-center text-sm text-[#52525B] mt-8">
        <Link to="/login" className="text-[#C8A96A] underline underline-offset-4">{lang === "tr" ? "Girişe dön" : "Back to sign in"}</Link>
      </p>
    </div>
  );
}
